import { formatWiseScore } from '@vw/core/src/score';
import { compactNumber, formatDuration } from '@vw/core/src/format-number';
/** Number/date formatting shared by pages (English only, SPEC §21 decision 19). */
/** "1.2K", "12K", "1.0M": never "1000K" at a unit's edge (packages/core/src/format-number.ts). */
export const compact = compactNumber;
export const pct = (x: number | null | undefined, digits = 1) => (x === null || x === undefined ? '–' : `${(x * 100).toFixed(digits)}%`);
/** Wise Scores and other "× usual" ratios: the one format from packages/core (truncated, "84×" / "9.9×"). */
export const mult = formatWiseScore;
/** "45 s", "1:05", "2:00" (never "1:60"). */
export const duration = formatDuration;
export const date = (ms: number | null | undefined, timeZone?: string) =>
  ms ? new Date(ms).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone }) : '–';
export function ago(ms: number | null | undefined, now = Date.now()): string {
  if (!ms) return 'never';
  const m = Math.round((now - ms) / 60_000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 48) return `${h} h ago`;
  return `${Math.round(h / 24)} days ago`;
}
export const igReel = (shortcode: string) => `https://www.instagram.com/reel/${encodeURIComponent(shortcode)}/`;
/** Instagram's official embed of a reel (decision 81: the player when no video is saved). The CSP allows it in frame-src. */
export const igEmbedUrl = (shortcode: string) => `https://www.instagram.com/reel/${encodeURIComponent(shortcode)}/embed/`;
/**
 * The embed's sandbox: Instagram's player needs its own scripts and cookies (same origin = instagram.com, never ours:
 * the frame is cross-origin) and opens instagram.com in a new tab from its links. No top navigation, forms or downloads.
 */
export const IG_EMBED_SANDBOX = 'allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox';
export const igReelsTab = (handle: string) => `https://www.instagram.com/${encodeURIComponent(handle)}/reels/`;
